(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kraven-email-capture-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kraven-email-capture')) {
    class KravenEmailCapture extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.storageKey = this.dataset.storageKey || 'kraven-home-sale-popup';
        this.delay = Number(this.dataset.delay) || 4000;
        this.dismissDays = Number(this.dataset.dismissDays) || 7;
        this.success = Boolean(this.querySelector('[data-capture-success]'));
        this.error = Boolean(this.querySelector('[data-capture-error]'));
        this.lastFocused = null;
        this.captchaObserver = new MutationObserver(() => this.tagCaptchaContainers());
        this.tagCaptchaContainers();
        this.captchaObserver.observe(document.body, { childList: true, subtree: true });

        this.querySelectorAll('[data-popup-close]').forEach((button) => {
          button.addEventListener('click', () => this.dismiss());
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dismiss();
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dismiss();
        });

        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('kraven-email-capture-open');
          this.tagCaptchaContainers();
          if (this.lastFocused && this.lastFocused.isConnected) this.lastFocused.focus({ preventScroll: true });
        });

        const form = this.querySelector('form');
        if (form) {
          form.addEventListener('submit', () => {
            const submit = form.querySelector('[data-popup-submit]');
            if (!submit) return;
            submit.disabled = true;
            submit.setAttribute('aria-busy', 'true');
          });
        }

        if (this.success) {
          this.writeState('subscribed', 365);
          this.whenLoaded(() => this.open());
          return;
        }

        if (this.error) {
          this.whenLoaded(() => this.open());
          return;
        }

        if (!this.isCampaignActive() || this.hasActiveState() || this.wasShownThisSession()) return;
        this.whenLoaded(() => {
          window.setTimeout(() => this.open(), this.delay);
        });
      }

      whenLoaded(callback) {
        if (document.readyState === 'complete') {
          callback();
          return;
        }
        window.addEventListener('load', callback, { once: true });
      }

      isCampaignActive() {
        if (!this.dataset.campaignEnd) return true;
        const end = Date.parse(this.dataset.campaignEnd);
        return Number.isNaN(end) || Date.now() <= end;
      }

      wasShownThisSession() {
        try {
          return window.sessionStorage.getItem(`${this.storageKey}:shown`) === 'true';
        } catch (error) {
          return false;
        }
      }

      hasActiveState() {
        try {
          const saved = JSON.parse(window.localStorage.getItem(this.storageKey));
          if (!saved || !saved.expiresAt) return false;
          if (Date.now() < saved.expiresAt) return true;
          window.localStorage.removeItem(this.storageKey);
          return false;
        } catch (error) {
          return false;
        }
      }

      writeState(status, days) {
        try {
          const expiresAt = Date.now() + days * 86400000;
          window.localStorage.setItem(this.storageKey, JSON.stringify({ status, expiresAt }));
        } catch (error) {
          return;
        }
      }

      tagCaptchaContainers() {
        const localCaptchaNodes = this.querySelectorAll(
          '.h-captcha, iframe[src*="hcaptcha" i], iframe[title*="hcaptcha" i]'
        );
        if (localCaptchaNodes.length) this.popupCaptchaActivated = true;

        localCaptchaNodes.forEach(
          (node) => {
            const container = node.closest('.h-captcha') || node;
            container.dataset.kravenPopupCaptcha = 'true';
          }
        );

        const response = this.querySelector('[name="h-captcha-response"]');
        if (response) this.popupCaptchaActivated = true;

        const badge = document.getElementById('shop-hcaptcha-badge-container');
        if (badge && this.popupCaptchaActivated) {
          badge.dataset.kravenPopupCaptcha = 'true';
        }

        const widgetId = response?.id?.replace('h-captcha-response-', '');
        if (!widgetId) return;

        document
          .querySelectorAll('body > div iframe[src*="hcaptcha" i], body > div iframe[title*="hcaptcha" i]')
          .forEach((frame) => {
            if (!frame.src.includes(`id=${widgetId}`)) return;
            let container = frame;
            while (container.parentElement && container.parentElement !== document.body) {
              container = container.parentElement;
            }
            container.dataset.kravenPopupCaptcha = 'true';
          });
      }

      open() {
        if (this.dialog.open || !this.isCampaignActive()) return;
        this.lastFocused = document.activeElement;
        try {
          window.sessionStorage.setItem(`${this.storageKey}:shown`, 'true');
        } catch (error) {
          this.dataset.sessionStorageUnavailable = 'true';
        }
        document.documentElement.classList.add('kraven-email-capture-open');
        this.tagCaptchaContainers();
        this.dialog.showModal();
        const focusTarget = this.success
          ? this.querySelector('.kraven-email-capture__shop-button')
          : this.querySelector('input[type="email"]');
        window.requestAnimationFrame(() => focusTarget?.focus({ preventScroll: true }));
      }

      dismiss() {
        if (!this.success) this.writeState('dismissed', this.dismissDays);
        if (this.dialog.open) this.dialog.close();
      }
    }

    customElements.define('kraven-email-capture', KravenEmailCapture);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kraven-product-runway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__kravenRunwaySwatchesReady) return;
    window.__kravenRunwaySwatchesReady = true;

    const swatchSelector = '.kraven-runway .kraven-card-swatch[data-preview-src]';

    const getParts = (swatch) => {
      const card = swatch.closest('.kraven-runway__product');
      const media = card?.querySelector('[data-kraven-media]');
      const image = media?.querySelector('.kraven-runway__image--primary');
      return { media, image };
    };

    const rememberOriginal = (image) => {
      if (image.dataset.kravenOriginalSrc) return;
      image.dataset.kravenOriginalSrc = image.getAttribute('src') || '';
      image.dataset.kravenOriginalSrcset = image.getAttribute('srcset') || '';
      image.dataset.kravenOriginalSizes = image.getAttribute('sizes') || '';
      image.dataset.kravenOriginalAlt = image.getAttribute('alt') || '';
    };

    const preview = (swatch) => {
      const source = swatch.dataset.previewSrc;
      const { media, image } = getParts(swatch);
      if (!source || !media || !image) return;

      rememberOriginal(image);
      const requestId = `${Date.now()}-${Math.random()}`;
      media.dataset.kravenPreviewRequest = requestId;
      media.classList.add('is-variant-loading');

      const preload = new Image();
      preload.decoding = 'async';
      preload.onload = () => {
        if (media.dataset.kravenPreviewRequest !== requestId) return;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = source;
        image.alt = swatch.dataset.previewAlt || image.dataset.kravenOriginalAlt;
        media.classList.remove('is-variant-loading');
        media.classList.add('is-variant-preview');
      };
      preload.onerror = () => {
        if (media.dataset.kravenPreviewRequest === requestId) {
          media.classList.remove('is-variant-loading');
        }
      };
      preload.src = source;
    };

    const restore = (swatch) => {
      const { media, image } = getParts(swatch);
      if (!media || !image || !image.dataset.kravenOriginalSrc) return;

      media.dataset.kravenPreviewRequest = '';
      image.src = image.dataset.kravenOriginalSrc;
      if (image.dataset.kravenOriginalSrcset) {
        image.setAttribute('srcset', image.dataset.kravenOriginalSrcset);
      } else {
        image.removeAttribute('srcset');
      }
      if (image.dataset.kravenOriginalSizes) {
        image.setAttribute('sizes', image.dataset.kravenOriginalSizes);
      } else {
        image.removeAttribute('sizes');
      }
      image.alt = image.dataset.kravenOriginalAlt;
      media.classList.remove('is-variant-loading', 'is-variant-preview');
    };

    document.addEventListener('pointerover', (event) => {
      const swatch = event.target.closest?.(swatchSelector);
      if (!swatch || swatch.contains(event.relatedTarget)) return;
      preview(swatch);
    });

    document.addEventListener('pointerout', (event) => {
      const swatch = event.target.closest?.(swatchSelector);
      if (!swatch || swatch.contains(event.relatedTarget)) return;
      restore(swatch);
    });

    document.addEventListener('focusin', (event) => {
      const swatch = event.target.closest?.(swatchSelector);
      if (swatch) preview(swatch);
    });

    document.addEventListener('focusout', (event) => {
      const swatch = event.target.closest?.(swatchSelector);
      if (swatch && !swatch.contains(event.relatedTarget)) restore(swatch);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kraven-transformation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kraven-comparison')) {
    customElements.define(
      'kraven-comparison',
      class extends HTMLElement {
        connectedCallback() {
          const range = this.querySelector('[data-compare-range]')
          range?.addEventListener('input', () => {
            this.style.setProperty('--compare-position', `${range.value}%`)
          })
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
